export const CATEGORY_EVENTS = {
  SELECT_CATEGORY: "web_select_category",
  SELECT_SEE_ALL_CATEGORY: "web_select_see_all_category",
};
